(function () {
  var DRAWER_SECTION = 'cart-drawer';
  var drawerOpen = false;
  var lastFocus = null;
  var pubsub = window.DisuriPubSub;
  var lineChangeInFlight = false;
  var giftAutoAddInFlight = false;
  var addInFlight = false;

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getContents() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-cart-drawer-contents]') : null;
  }

  function getPanel() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('.cart-drawer-panel') : null;
  }

  function getCartPage() {
    return document.querySelector('[data-cart-page]');
  }

  function getCartPageSectionId() {
    var page = getCartPage();
    return page ? page.getAttribute('data-cart-section-id') : null;
  }

  function publishCartUpdate(source, cartData, variantId) {
    if (!pubsub) return;
    pubsub.publish(pubsub.events.cartUpdate, {
      source: source,
      cartData: cartData,
      productVariantId: variantId,
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
  }

  function publishCartError(source, message, variantId) {
    if (message) {
      announceCartStatus(message, true);
    }
    if (!pubsub) return;
    pubsub.publish(pubsub.events.cartError, {
      source: source,
      message: message,
      productVariantId: variantId,
    });
  }

  function announceCartStatus(message, isError) {
    var el = document.getElementById('cart-status');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.remove('visually-hidden');
    el.classList.toggle('is-error', !!isError);
    clearTimeout(announceCartStatus._timer);
    announceCartStatus._timer = setTimeout(function () {
      el.textContent = '';
      el.classList.add('visually-hidden');
      el.classList.remove('is-error');
    }, 5000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count <= 0;
    });
  }

  function genericCartError() {
    var el = document.getElementById('cart-status');
    return (
      (el && el.getAttribute('data-generic-error')) ||
      'Something went wrong. Please try again.'
    );
  }

  function parseCartResponse(res) {
    return res
      .json()
      .catch(function () {
        return {};
      })
      .then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || genericCartError());
        }
        return data;
      });
  }

  function readGiftAutoAddConfig() {
    var el =
      document.querySelector('[data-cart-page] [data-disuri-gift-auto-add-config]') ||
      document.querySelector('[data-disuri-gift-auto-add-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function removeGiftLine(lineKey) {
    return fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then(parseCartResponse)
      .then(function (cart) {
        updateCartCount(cart.item_count);
        publishCartUpdate('gift-auto-remove', cart);
        return Promise.all([refreshDrawer(), refreshCartPage()]);
      })
      .catch(function (err) {
        console.error('Gift auto-remove failed', err);
      });
  }

  function maybeAutoAddGift(depth) {
    depth = depth || 0;
    if (giftAutoAddInFlight) return Promise.resolve();

    var config = readGiftAutoAddConfig();
    if (!config) return Promise.resolve();

    var unlocked = Boolean(config.enabled) && config.skincareSubtotal >= config.goal;
    var gwpLines = Array.isArray(config.gwpLines) ? config.gwpLines : [];
    var currentVariantId = config.giftWeekVariantId || config.giftVariantId || null;

    // Remove any _gwp line that must not stay as a paid line:
    // - below threshold (or program disabled): every _gwp line goes;
    // - unlocked: any _gwp line from a *previous* week's rotation (stale
    //   variant) goes, so Thursday rotation never converts last week's gift
    //   into a charged item.
    var staleLines = gwpLines.filter(function (line) {
      if (!line || !line.key) return false;
      if (!unlocked) return true;
      return currentVariantId && line.variantId !== currentVariantId;
    });

    if (staleLines.length && depth < 2) {
      giftAutoAddInFlight = true;
      return staleLines
        .reduce(function (chain, line) {
          return chain.then(function () {
            return removeGiftLine(line.key);
          });
        }, Promise.resolve())
        .finally(function () {
          giftAutoAddInFlight = false;
        })
        .then(function () {
          // Re-read the refreshed config once so the current week's gift can
          // still be added after stale lines are cleared.
          return maybeAutoAddGift(depth + 1);
        });
    }

    if (!unlocked || config.giftInCart || !config.giftVariantId) return Promise.resolve();

    giftAutoAddInFlight = true;
    return addItem(String(config.giftVariantId), 1, 'gift-auto-add', {
      openDrawer: false,
      properties: { _gwp: '1' },
    })
      .catch(function () {
        // Gift add failure (e.g. sold out mid-week) must not break the main flow.
      })
      .finally(function () {
        giftAutoAddInFlight = false;
      });
  }

  function afterCartMutation(refreshPromise) {
    return Promise.resolve(refreshPromise).then(function () {
      return maybeAutoAddGift();
    });
  }

  // Re-rendering the drawer/cart replaces the control the keyboard user just
  // activated, dropping focus to <body>. Capture the control's identity (line
  // index + accessible label) before the swap and re-focus its counterpart.
  function captureFocusTarget(container) {
    var active = document.activeElement;
    if (!container || !active || !container.contains(active)) return null;
    var control = active.closest('[data-cart-qty-change]');
    if (!control) return null;
    return {
      line: control.getAttribute('data-line'),
      label: control.getAttribute('aria-label') || control.textContent.trim(),
    };
  }

  function restoreFocusTarget(root, target, fallback) {
    if (!target || !root) return;
    var candidates = root.querySelectorAll(
      '[data-cart-qty-change][data-line="' + target.line + '"]'
    );
    var match = null;
    Array.prototype.forEach.call(candidates, function (btn) {
      var label = btn.getAttribute('aria-label') || btn.textContent.trim();
      if (!match && label === target.label) match = btn;
    });
    if (!match && candidates.length) match = candidates[0];
    if (!match) match = root.querySelector('[data-cart-qty-change]');

    var el = match || fallback;
    if (el && typeof el.focus === 'function') {
      if (el === fallback && !el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '-1');
      }
      el.focus();
    }
  }

  function applyDrawerSectionHtml(html) {
    var contents = getContents();
    if (!html || !contents) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextPanel = doc.querySelector('.cart-drawer-panel');
    if (!nextPanel) return;

    var focusTarget = captureFocusTarget(contents);

    contents.innerHTML = nextPanel.outerHTML;
    prepareDrawerForCheckout();

    var panel = getPanel();
    if (drawerOpen && panel) {
      trapFocus(panel);
    }
    restoreFocusTarget(panel, focusTarget, panel);
  }

  function applyCartPageHtml(html) {
    var current = getCartPage();
    if (!html || !current) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-page]');
    if (!next) return;

    var focusTarget = captureFocusTarget(current);

    current.outerHTML = next.outerHTML;

    var page = getCartPage();
    restoreFocusTarget(page, focusTarget, page);
  }

  function trapFocus(panel) {
    if (window.DisuriA11y) {
      window.DisuriA11y.trapFocus(panel);
    }
  }

  function setTriggerExpanded(expanded) {
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    var panel = getPanel();
    if (!drawer || !panel) return;

    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    drawerOpen = true;
    setTriggerExpanded(true);
    panel.focus();
    trapFocus(panel);
    prepareDrawerForCheckout();
  }

  function prepareDrawerForCheckout() {
    var scroll = document.querySelector('[data-cart-drawer-scroll]');
    if (scroll) {
      scroll.scrollTop = 0;
    }
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    drawerOpen = false;
    setTriggerExpanded(false);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function refreshDrawer() {
    var url = routesRoot() + '?sections=' + encodeURIComponent(DRAWER_SECTION);
    return fetch(url)
      .then(parseCartResponse)
      .then(function (data) {
        applyDrawerSectionHtml(data[DRAWER_SECTION]);
      })
      .catch(function (err) {
        console.error('Cart drawer refresh failed', err);
      });
  }

  function refreshCartPage() {
    var sectionId = getCartPageSectionId();
    if (!sectionId) return Promise.resolve();

    var url = routesRoot() + 'cart?sections=' + encodeURIComponent(sectionId);
    return fetch(url)
      .then(parseCartResponse)
      .then(function (data) {
        applyCartPageHtml(data[sectionId]);
      })
      .catch(function (err) {
        console.error('Cart page refresh failed', err);
      });
  }

  function setCartBusy(isBusy) {
    var page = getCartPage();
    if (page) {
      page.classList.toggle('is-updating', isBusy);
    }
    var drawer = getDrawer();
    if (drawer) {
      drawer.classList.toggle('is-updating', isBusy);
    }
  }

  function changeLine(line, quantity, source) {
    if (lineChangeInFlight) return Promise.resolve();
    lineChangeInFlight = true;
    setCartBusy(true);

    return fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
    })
      .then(parseCartResponse)
      .then(function (cart) {
        updateCartCount(cart.item_count);
        publishCartUpdate(source || 'cart', cart);
        return afterCartMutation(Promise.all([refreshDrawer(), refreshCartPage()]));
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        publishCartError(source || 'cart', err.message || genericCartError());
      })
      .finally(function () {
        lineChangeInFlight = false;
        setCartBusy(false);
      });
  }

  function appendSectionParams(formData) {
    formData.append('sections', DRAWER_SECTION);
    formData.append('sections_url', routesRoot());
    return formData;
  }

  function handleAddResponse(response, source, variantId) {
    if (response.status) {
      throw new Error(response.description || response.message);
    }

    if (response.sections && response.sections[DRAWER_SECTION]) {
      applyDrawerSectionHtml(response.sections[DRAWER_SECTION]);
    }

    return fetch(routesRoot() + 'cart.js')
      .then(parseCartResponse)
      .then(function (cart) {
        updateCartCount(cart.item_count);
        publishCartUpdate(source, cart, variantId);
        var refresh = !response.sections || !response.sections[DRAWER_SECTION]
          ? refreshDrawer()
          : refreshCartPage();
        return afterCartMutation(refresh);
      });
  }

  function addItem(variantId, quantity, source, options) {
    source = source || 'quick-add';
    quantity = quantity || 1;
    options = options || {};

    // Single-flight lock for user-initiated adds; the gift auto-add runs inside
    // an outer add's promise chain, so it must bypass the lock.
    var useLock = source !== 'gift-auto-add';
    if (useLock) {
      if (addInFlight) return Promise.resolve();
      addInFlight = true;
    }

    var formData = appendSectionParams(new FormData());
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    if (options.properties) {
      Object.keys(options.properties).forEach(function (key) {
        formData.append('properties[' + key + ']', options.properties[key]);
      });
    }

    return fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(parseCartResponse)
      .then(function (response) {
        return handleAddResponse(response, source, variantId);
      })
      .then(function (result) {
        if (options.openDrawer !== false) {
          openDrawer();
        }
        return result;
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        publishCartError(source, err.message || genericCartError(), variantId);
        throw err;
      })
      .finally(function () {
        if (useLock) {
          addInFlight = false;
        }
      });
  }

  function addToCart(form) {
    if (addInFlight) return Promise.resolve();
    addInFlight = true;

    var submitBtn = form.querySelector('[type="submit"]');
    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : null;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    var formData = appendSectionParams(new FormData(form));

    return fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(parseCartResponse)
      .then(function (response) {
        return handleAddResponse(response, 'product-form', variantId);
      })
      .then(function (result) {
        openDrawer();
        return result;
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        publishCartError('product-form', err.message || genericCartError(), variantId);
      })
      .finally(function () {
        addInFlight = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var quantity = parseInt(qtyBtn.getAttribute('data-quantity'), 10);
      if (Number.isNaN(line)) return;
      var source = qtyBtn.closest('[data-cart-page]') ? 'cart-page' : 'cart-drawer';
      changeLine(line, quantity, source);
      return;
    }

    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      if (quickAdd.getAttribute('aria-disabled') === 'true') return;

      var variantId = quickAdd.getAttribute('data-variant-id');
      if (!variantId) return;

      var bundleHero = quickAdd.closest('[data-bundle-hero]');
      var fromSkinGuide = Boolean(bundleHero);

      quickAdd.setAttribute('aria-disabled', 'true');
      quickAdd.classList.add('is-loading');

      addItem(variantId, 1, fromSkinGuide ? 'skin-guide-bundle' : 'quick-add', {
        openDrawer: !fromSkinGuide,
      }).finally(function () {
        quickAdd.removeAttribute('aria-disabled');
        quickAdd.classList.remove('is-loading');
      });
      return;
    }

    var orderBumpAdd = e.target.closest('[data-order-bump-add]');
    if (orderBumpAdd) {
      e.preventDefault();
      if (orderBumpAdd.getAttribute('aria-disabled') === 'true') return;

      var bumpVariantId = orderBumpAdd.getAttribute('data-variant-id');
      if (!bumpVariantId) return;

      orderBumpAdd.setAttribute('aria-disabled', 'true');
      orderBumpAdd.classList.add('is-loading');

      addItem(bumpVariantId, 1, 'order-bump').finally(function () {
        orderBumpAdd.removeAttribute('aria-disabled');
        orderBumpAdd.classList.remove('is-loading');
      });
      return;
    }

    var openTrigger = e.target.closest('[data-cart-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
      return;
    }

    if (e.target.closest('[data-cart-close]') && drawerOpen) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpen) {
      closeDrawer();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart-form]')) return;
    if (!window.fetch) return;

    e.preventDefault();
    addToCart(form);
  });

  window.DisuriCart = {
    addItem: addItem,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    refreshDrawer: refreshDrawer,
    refreshCartPage: refreshCartPage,
    changeLine: changeLine,
    maybeAutoAddGift: maybeAutoAddGift,
  };

  document.addEventListener('DOMContentLoaded', function () {
    afterCartMutation(Promise.resolve());
  });
})();
